import { RSB_URL } from 'helpers/common/rsb';

export const footer: FooterSetup = {
    buttonLabel: 'Give us feedback',
    buttonLink: 'https://kromatic.com/feedback?app=innovation-accounting-app',
    links: [
        {
            label: 'The Real Startup Book — the framework behind this tool',
            href: RSB_URL,
        },
        {
            label: 'Privacy Policy',
            href: 'https://kromatic.com/privacy-policy',
        },
        {
            label: 'Terms of Service',
            href: 'https://kromatic.com/terms-of-service',
        },
    ],
    poweredBy: true,
};
